import BaseComponent from '../../../js/base-component'
import { Loader } from "@googlemaps/js-api-loader"

class Store extends BaseComponent {
    constructor(options) {
        super(options);

        const apiKey = "AIzaSyBQ_aCybg5OOLgDeSGbDDptzH2hQ_vTfgA"; // seeger live -- AIzaSyDLMPo5PSk4wq8Z67lS7m72fmdnRJ6CCxA

        this.mapContainer = document.querySelector(".u-store__map");

        window.addEventListener('CookiebotOnAccept', (e) => {
            if (Cookiebot.consent.preferences) {
                this.consent = Cookiebot.consent.preferences;

                // load Maps, apikey & version
                this.loader = new Loader({
                    apiKey: apiKey,
                    version: "weekly",
                });

                if ( this.mapContainer && this.consent ) {
                    this.loadMap();
                }
            }
        }, false);
    }

    loadMap() {
        const title = this.mapContainer.dataset.title;
        const lat = Number(this.mapContainer.dataset.lat);
        const lng = Number(this.mapContainer.dataset.lng);

        this.mapContainer.classList.remove('not-loaded');

        this.loader.load().then(() => {
            let map = new google.maps.Map(this.mapContainer, {
                center: { lat: lat, lng: lng },
                fullscreenControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                zoomControl: false,
                zoom: 14,
            });

            new google.maps.Marker({
                position: { lat: lat, lng: lng },
                map,
                // title: title,
                // icon: {
                //     scaledSize: new google.maps.Size(30, 56),
                //     url: '/var/assets/Medien/Icons/map/seeger-pin.png'
                // },
            });
        });
    }
}

export default {
  name: 'Store',
  definition: Store
};
